/* global FontFaceObserver */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    if (window.FontFaceObserver !== undefined) {
      var font = new FontFaceObserver('proxima-nova', {
        weight: 400
      });
      font.load(null, 15000).then(function () {
        document.documentElement.classList.add('fonts-loaded');
      }, function () {
        document.documentElement.classList.add('fonts-not-loaded');
      });
    }
  }
})();
/* global loadJS, LazyLoad */
(function () {
  var classList = document.documentElement.classList;

  function loadLazyLoad() {
    loadJS('/js/lazyload/lazyload.min.js', function () {
      return new LazyLoad({
        elements_selector: '.lazy'
      });
    });
  }

  if (classList.contains('no-promises')) {
    loadJS('/js/polyfills/polyfill.min.js', true);
  }
  /*
  if (classList.contains('no-objectfit')) {
      loadJS('/js/polyfills/objectFitPolyfill.min.js', true)
  }
  */


  if (!('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window) || !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    document.documentElement.classList.add('no-intersectionobserver');
    loadJS('/js/polyfills/intersection-observer.js', loadLazyLoad);
  } else {
    document.documentElement.classList.add('intersectionobserver');
    loadLazyLoad();
  }
  /*
  if (classList.contains('no-fetch')) {
      loadJS('/js/polyfills/fetch.umd.js')
  }
  */

})();
require("core-js/modules/es.array.find");

require("core-js/modules/es.array.index-of");

require("core-js/modules/web.timers");

/* global $ */

/* global jQuery */

/* global loadJS */
jQuery(function () {
  $.nette.init();
  $('body').on('click', '.confirm', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var text = $(this).data('confirm-text');

    if (confirm(text ? '' + text : $('html').attr('lang') === 'cs' ? 'Opravdu smazat tento záznam?' : 'Do you really want to delete this record?')) {
      document.location = $(this).attr('href');
    }
  });

  if ($('#ajaxSpinner').length > 0) {
    $(document).on('ajaxStart', function () {
      $('#ajaxSpinner').addClass('loading');
    });
    $(document).on('ajaxStop', function () {
      $('#ajaxSpinner').removeClass('loading');
    });
  }

  $.nette.ext({
    before: function before() {
      $('form.ajax').addClass('loading');
    },
    complete: function complete() {
      $('form.ajax').removeClass('loading');
    }
  }); // DYNAMIC GRECAPTCHA LOADER

  var grecaptchaLoading = false;

  if ($('form .g-recaptcha').length > 0) {
    if (window.grecaptcha === undefined) {
      $('form input').on('focus', function () {
        if (!grecaptchaLoading && window.grecaptcha === undefined) {
          grecaptchaLoading = true;
          loadJS('/js/recaptcha/recaptcha.invisible.ajax.js', function () {
            grecaptchaLoading = false;
          });
        }
      });
    }
  } // IFRAME SRC TOGGLE


  (function () {
    var tm;
    $('body').on('click', 'a[data-toggle-iframe]', function (event) {
      var el = $(event.target);
      var iframe = $(el.data('iframe'));

      if (iframe.length === 1) {
        clearTimeout(tm);
        iframe.attr('src', '');
        tm = setTimeout(function () {
          iframe.attr('src', el.data('iframe-src'));
        }, 100);
      }
    });
  })();
});
jQuery(function () {
  $('.btn-aspena-submit').on('click', function (event) {
    var input = $(event.target).find('input[type="submit"]').first();

    if (input.length > 0) {
      input.get(0).click();
    }
  });
});
jQuery(function () {
  $.nette.ext('dataLayer', {
    success: function success(payload, status, jqXHR, settings) {
      if (payload.hasOwnProperty('snippets')) {
        if (payload.snippets.hasOwnProperty('snippet-aspenaDemandForm-snpDemandForm') && payload.snippets['snippet-aspenaDemandForm-snpDemandForm'].indexOf('form-wrapper') === -1) {
          window.dataLayer.push({
            event: 'formPoptavka'
          });
        }

        if (payload.snippets.hasOwnProperty('snippet-replyForm-snpReplyForm') && payload.snippets['snippet-replyForm-snpReplyForm'].indexOf('form-wrapper') === -1) {
          window.dataLayer.push({
            event: 'formKariera'
          });
        }
      }
    }
  });
});
require("core-js/modules/es.array.is-array");

/* global toastr */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    document.body.classList.add('site-onready');
    setToastrDefaults();
    showFlashMessages();
  }

  function setToastrDefaults() {
    if (Object.prototype.hasOwnProperty.call(window, 'toastr')) {
      toastr.options = {
        'closeButton': true,
        'progressBar': true
      };
    }
  }

  function showFlashMessages() {
    if (window._cmsFlashMessages !== undefined && Array.isArray(window._cmsFlashMessages) && window._cmsFlashMessages.length > 0) {
      for (var index in window._cmsFlashMessages) {
        var item = window._cmsFlashMessages[index];

        switch (item.type) {
          case 'success':
            toastr.success(item.message);
            break;

          case 'error':
            toastr.error(item.message);
            break;

          case 'warning':
            toastr.warning(item.message);
            break;

          default:
            toastr.info(item.message);
        }
      }

      window._cmsFlashMessages = [];
    }
  }

  window.dataLayer = window.dataLayer || [];
})();
/* global Swiper */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function initSwiper(elementId) {
    var el = document.getElementById(elementId);

    if (el) {
      var settings = el.dataset.componentConfig;

      if (typeof settings === 'string') {
        settings = JSON.parse(settings);
      }

      return new Swiper('#' + elementId, settings);
    }

    return null;
  }

  function run() {
    if (window.Swiper !== undefined) {
      window.homepageSlider = initSwiper('sliderComponent-imiVentilSlider');
    }
  }
})();
/* global SmoothScroll */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    if (window.SmoothScroll !== undefined) {
      /* eslint-disable-next-line no-unused-vars */
      var scroll = new SmoothScroll('a[data-scroll][href*="#"]');
    }
  }
})();
require("core-js/modules/web.timers");

(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  var tm;
  var prevPosition = 0;
  var position = 0;

  function checkStickyMenu() {
    position = window.pageYOffset;
    var body = document.body;
    var isActive = body.classList.contains('sticky-header');

    if (position > 150) {
      if (!isActive) {
        body.classList.add('sticky-header-no-transition');
        setTimeout(function () {
          body.classList.remove('sticky-header-no-transition');
        }, 50);
        body.classList.add('sticky-header');
      }

      if (position - prevPosition < 0 && isActive) {
        body.classList.add('sticky-header-up');
      } else {
        body.classList.remove('sticky-header-up');
      }
    } else {
      body.classList.remove('sticky-header-no-transition');
      body.classList.remove('sticky-header');
      body.classList.remove('sticky-header-up');
    }

    prevPosition = position;
  }

  function run() {
    document.addEventListener('scroll', function (event) {
      clearTimeout(tm);
      tm = setTimeout(checkStickyMenu, 25);
    });
    checkStickyMenu();
  }
})();
require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    var elements = document.querySelectorAll("a[href^='mailto:']");

    if (elements.length > 0) {
      for (var index in elements) {
        var element = elements[index];

        if (element instanceof Node) {
          element.setAttribute('href', element.getAttribute('href').replace(/(#zavinac#)/ig, '@'));
          element.innerHTML = element.innerHTML.replace(/(#zavinac#)/ig, '@');
        }
      }
    }
  }
})();
/* global Flickity */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function forceLoadImages(selector) {
    var images = document.querySelectorAll(selector + ' img[data-src].lazy');

    for (var index in images) {
      var img = images[index];

      if (img instanceof Node) {
        if (img.dataset.wasProcessed !== 'true') {
          img.setAttribute('src', img.dataset.src);
          img.dataset.wasProcessed = 'true';
        }
      }
    }
  }

  function initAspenaReferencesFlickity() {
    var elements = document.querySelectorAll('.vd-references');
    forceLoadImages('.vd-references');
    var instances = [];

    for (var index in elements) {
      var element = elements[index];

      if (element instanceof Node) {
        instances.push({
          element: element,
          flickity: new Flickity(element, {
            cellAlign: 'center',
            contain: true,
            watchCSS: true,
            pageDots: false,
            imagesLoaded: true,
            setGallerySize: false,
            cellSelector: '.vd-reference-logo-wrapper',
            arrowShape: 'M99 43.81V56.2H24.76L58.79 90.2 50 99 1 50 50 1l8.79 8.79L24.76 43.8z'
          })
        });
      }
    }

    return instances;
  }

  function initVdSlidersFlickity() {
    var elements = document.querySelectorAll('.vd-slider');
    forceLoadImages('.vd-slider');
    var instances = [];

    for (var index in elements) {
      var element = elements[index];

      if (element instanceof Node) {
        instances.push({
          element: element,
          flickity: new Flickity(element, {
            cellAlign: 'center',
            contain: true,
            pageDots: element.dataset.pageDots === 'true',
            prevNextButtons: element.dataset.navigationButtons === 'true',
            imagesLoaded: true,
            cellSelector: '.vd-slider-slide',
            arrowShape: 'M99 43.81V56.2H24.76L58.79 90.2 50 99 1 50 50 1l8.79 8.79L24.76 43.8z'
          })
        });
      }
    }

    return instances;
  }

  function run() {
    if (window.Flickity !== undefined) {
      // initAspenaReferencesFlickity()
      initVdSlidersFlickity();
    }
  }
})();
require("core-js/modules/es.array.find");

require("core-js/modules/web.timers");

/* global jQuery, $ */
jQuery(function () {
  var tm;
  var rTm;
  var mediaQueryMatch = false;
  var mediaQueryList = window.matchMedia('(min-width: 992px)');
  var mobileMenuOpen = false;
  var pTm;

  try {
    mediaQueryList.addEventListener('change', onMediaQueryChange);
  } catch (err) {
    $(window).on('resize', function () {
      clearTimeout(pTm);
      pTm = setTimeout(function () {
        onMediaQueryChange(window.matchMedia('(min-width: 992px)'));
      }, 25);
    });
  }

  onMediaQueryChange(mediaQueryList);
  $('button.dropdown-mobile-toggle').on('click', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    if ($(this).parent().attr('aria-expanded') === 'true') {
      $(this).parent().attr('aria-expanded', 'false').parent().find('.dropdown-menu').first().removeClass('show');
    } else {
      $(this).parent().attr('aria-expanded', 'true').parent().find('.dropdown-menu').first().addClass('show');
    }
  });

  function onMediaQueryChange(queryList) {
    var oldValue = !!mediaQueryMatch;
    mediaQueryMatch = queryList.matches === true;

    if (oldValue !== mediaQueryMatch) {
      resetTimeouts();

      if (oldValue) {
        $('.mega-dropdown-dropdown-toggle').attr('aria-expanded', 'true');
      } else {
        $('.mega-dropdown-dropdown-toggle').attr('aria-expanded', 'false');
      }
    }

    if (mediaQueryMatch) {
      $('html').removeClass('mobile-menu-open');
    } else {
      if (mobileMenuOpen) {
        $('html').addClass('mobile-menu-open');
      }
    }
  }

  $('.navbar-toggler').on('click', function () {
    $('html').toggleClass('mobile-menu-open');
    mobileMenuOpen = $('html').hasClass('mobile-menu-open');
    resetDropdowns();
  });

  function attachListeners() {
    $('.navbar-vd .nav-item.dropdown.position-static > [data-toggle="dropdown"]').on('mouseenter mouseover focus', setDisplayTimeout);
    $('.navbar-vd').on('mouseleave', setResetDropdownsTimeout);
    $('.navbar-vd .dropdown-menu').on('mouseenter', resetTimeouts);
    $('body > .main-content').on('click mouseenter', setResetDropdownsTimeout);
    $('.navbar-vd .top-level-link').on('mouseenter', setResetDropdownsTimeout);
  }

  function resetTimeouts() {
    clearTimeout(tm);
    clearTimeout(rTm);
  }

  function setResetDropdownsTimeout() {
    if (mediaQueryMatch) {
      clearTimeout(rTm);
      rTm = setTimeout(function () {
        resetDropdowns();
      }, 250);
    }
  }

  function resetDropdowns() {
    $('.navbar-vd [data-toggle="dropdown"][aria-expanded="true"]').attr('aria-expanded', 'false');
    $('.navbar-vd .dropdown-menu.show').removeClass('show');
  }

  function setDisplayTimeout(event) {
    if (mediaQueryMatch) {
      if ($('.navbar-vd .dropdown-menu.show').length > 0) {
        tm = setTimeout(function () {
          displayDropdown(event);
        }, 400);
      } else {
        displayDropdown(event);
      }
    }
  }

  function displayDropdown(event) {
    if (mediaQueryMatch) {
      if ($(event.target).attr('aria-expanded') === 'false') {
        resetDropdowns();
        $(event.target).attr('aria-expanded', 'true').parent().find('.dropdown-menu').first().addClass('show');
      }
    }
  }

  attachListeners();
});
jQuery(function () {
  if (typeof $('body').lightGallery === 'function' && $('[data-gallery]').length > 0) {
    $('[data-gallery]').each(function () {
      var wrapper = $(this);
      var options = wrapper.data('gallery') !== '' ? wrapper.data('gallery') : {};
      wrapper.lightGallery(options);
    });
  }
});